import React, { Suspense, useEffect, useState } from "react";
import Header from "../../../components/Header/index";
import style from "./Question.module.scss";
import QuestionHeader from "./components/QuestionHeader/index";
import QuestionBody from "./components/QuestionBody/index";
import { Spin, message } from "antd";
// const AnswerEditor = React.lazy(() => import("./components/AnswerEditor"));
import AnswerEditor from "./components/AnswerEditor/index";

import { RouteComponentProps } from "react-router-dom";
import { getTidDufe, replyQuestion, errorMessage } from "service/service";
import usePromiseCallback from "utils/usePromiseCallback";

interface IPageQuestionProps extends RouteComponentProps<{ id: string }> {}

export interface QAItem {
    tid: string;
    pid: string;
    title: string;
    name: string;
    addtime: string;
    content: string;
    istopic: string;
}

const defaultData = {
    tid: "",
    pid: "",
    title: "",
    name: "",
    addtime: "",
    content: "",
    istopic: ""
};

export default function PageQuestion(props: IPageQuestionProps) {
    let [stuInfo, setStuInfo] = useState<QAItem>(defaultData);
    let [teacherInfo, setTeacherInfo] = useState<QAItem>(defaultData);

    useEffect(() => {
        getTidDufe(props.match.params.id).then(res => {
            let data = res.data.data;
            let stu = data.find(item => item.istopic === "1")!;
            let teacher = data.find(item => item.istopic === "0");
            teacher && setTeacherInfo(teacher);
            setStuInfo(stu);
        });
    }, []);

    const handleSubmit = usePromiseCallback(async (content: string) => {
        return replyQuestion(stuInfo.title, content, props.match.params.id)
            .then(res =>
                message.loading("回复成功，正在返回", 1.5).then(
                    res => props.history.goBack(),
                    err => {}
                )
            )
            .catch(e => {
                return message.error(errorMessage(e));
            });
    });

    return (
        <div>
            <Header />

            <div className={style.root}>
                <QuestionHeader
                    title={stuInfo.title}
                    studentName={stuInfo.name}
                    addtime={stuInfo.addtime}
                />
                <QuestionBody question={stuInfo} />

                <Suspense fallback={<Spin />}>
                    {stuInfo !== defaultData && (
                        <AnswerEditor
                            onSubmit={handleSubmit}
                            title={stuInfo.title}
                            content={teacherInfo.content}
                            tid={props.match.params.id}
                        />
                    )}
                </Suspense>
            </div>
        </div>
    );
}
